module.exports = __webpack_public_path__ + "static/KMNLogo-a6239c12e8a43fd9bb8a62ee71d31445.png";